import React, { useState } from 'react';
import InformationStep from './steps/InformationStep';
import PaymentStep from './steps/PaymentStep';
import './PaymentWizard.css';

interface PaymentWizardProps {
  onSubmit: (data: {
    totalAmount: string;
    originalAmount: string;
    platformFee: string;
    publicUserId: string;
    sellerId: string;
    itemId: string;
    paymentMethod: string;
    transactionId?: string;
  }) => void;
}

const PaymentWizard: React.FC<PaymentWizardProps> = ({ onSubmit }) => {
  const [currentStep, setCurrentStep] = useState<'information' | 'payment'>('information');
  const [paymentData, setPaymentData] = useState({
    amount: '',
    platformFee: '0.00',
    totalAmount: '0.00',
    publicUserId: '',
    sellerId: '',
    itemId: '',
    userValid: false,
    promotionCode: undefined as string | undefined,
    originalPlatformFee: undefined as string | undefined,
    appliedPromotion: undefined as any
  });

  const handleInformationSubmit = (data: any) => {
    setPaymentData({
      ...data,
      promotionCode: data.promotionCode,
      originalPlatformFee: data.originalPlatformFee,
      appliedPromotion: data.appliedPromotion
    });
    setCurrentStep('payment');
  };

  const handleBackToInformation = () => {
    setCurrentStep('information');
  };

  const handlePaymentSuccess = (transactionId: string) => {
    onSubmit({
      totalAmount: paymentData.totalAmount,
      originalAmount: paymentData.amount,
      platformFee: paymentData.platformFee,
      publicUserId: paymentData.publicUserId,
      sellerId: paymentData.sellerId,
      itemId: paymentData.itemId,
      paymentMethod: 'card',
      transactionId
    });
  };

  return (
    <div className="payment-wizard">
      {currentStep === 'information' ? (
        <InformationStep 
          initialData={paymentData}
          onSubmit={handleInformationSubmit}
        />
      ) : (
        <PaymentStep
          paymentData={paymentData}
          onBack={handleBackToInformation}
          onPaymentSuccess={handlePaymentSuccess}
        />
      )}
    </div>
  );
};

export default PaymentWizard;